import { ScopeButton } from '@monorepo/shared-lib';
import GuideStepOne from 'assets/images/main-guide-step1.svg';
import GuideStepTwo from 'assets/images/main-guide-step2.svg';
import GuideStepThree from 'assets/images/main-guide-step3.svg';
import { StyledCard } from 'components/Custom/card';
import { CardListSpan, CardTitleLargeSpan } from 'components/Custom/spans';
import { MAIN_TUTORIAL_HIDE } from 'pages/home';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultIconClose } from 'shared/styles/common';
import { Preference, PreferenceActions } from 'utils/preferences';

interface MainGuideProps {
  setShowCard: (show: boolean) => void;
  handlePreferences: (action: PreferenceActions, preference: Preference) => any;
  //renderTopButtons: () => React.ReactNode;
}

const msgBoxWrapper: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  minWidth: 300,
  maxWidth: 300,
  minHeight: 290,
};

export const MainGuide: React.FC<MainGuideProps> = ({
  setShowCard,
  handlePreferences,
  //renderTopButtons,
}) => {
  const { t } = useTranslation();

  const handleClose = () => {
    setShowCard(false);
    handlePreferences(PreferenceActions.SET, {
      name: MAIN_TUTORIAL_HIDE,
      value: true,
    });
  };

  return (
    <StyledCard
      width="100%"
      spreadcontent
      fullsize
      hideheader
      style={{
        marginBottom: '20px',
        width: '100%',
        position: 'relative',
      }}
      extra={
        <DefaultIconClose
          role="button"
          tabIndex={0}
          aria-label={t('common.close')}
          style={{
            top: '25',
            position: 'absolute',
            right: '25',
          }}
          onClick={handleClose}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleClose();
            }
          }}
        />
      }
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-around',
          width: '100%',
          flexWrap: 'wrap',
          //gap: 50,
        }}
      >
        <div style={msgBoxWrapper}>
          <div>
            <CardTitleLargeSpan>
              {t('submissions.connect-your-entity')}
            </CardTitleLargeSpan>

            <CardListSpan>
              <p style={{ paddingInlineStart: 3, maxWidth: 330, margin: 0 }}>
                {t('submissions.connect-your-entity-description')}
              </p>
            </CardListSpan>
          </div>
          <div style={{ marginBottom: 10 }}>
            <img alt={t('submissions.connect-your-entity')} src={GuideStepOne} />
          </div>
        </div>
        <div style={msgBoxWrapper}>
          <div>
            <CardTitleLargeSpan>
              {t('submissions.add-a-tax-return')}
            </CardTitleLargeSpan>
            <CardListSpan>
              <p style={{ paddingInlineStart: 3, maxWidth: 330, margin: 0 }}>
                {t('submissions.add-a-tax-return-description')}
              </p>
            </CardListSpan>
          </div>
          <div>
            <img alt={t('submissions.add-a-tax-return')} src={GuideStepTwo} />
          </div>
        </div>

        <div style={msgBoxWrapper}>
          <div>
            <CardTitleLargeSpan>
              {t('submissions.create-a-submission')}
            </CardTitleLargeSpan>
            <CardListSpan>
              <p style={{ paddingInlineStart: 3, maxWidth: 330, margin: 0 }}>
                {t('submissions.create-a-submission-description')}
              </p>
            </CardListSpan>
          </div>
          <div>
            <img
              alt={t('submissions.create-a-submission')}
              src={GuideStepThree}
            />
          </div>
        </div>
      </div>
      <ScopeButton
        type="default"
        onClick={handleClose}
        style={{
          position: 'absolute',
          bottom: 16,
          right: 16,
          width: 'auto',
          height: 28,
          fontSize: '12px',
          padding: '0 12px',
        }}
      >
        {t('common.close')}
      </ScopeButton>
    </StyledCard>
  );
};
